import React, { useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Card, Pagination, Table, Form, InputGroup } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import PromptService from "../../services/api/prompt";
import toast from "react-hot-toast";
import { extractTypes } from "../../settings/shared/constants";


const Instructions = (props) => {
    const [height, setHeight] = useState(window.innerHeight);
    const [instruction, setInstruction] = useState("");
    const [instructionDataSource, setInstructionDataSource] = useState([]);
    const [instructionName, setInstructionName] = useState("");
    const [instructionDescription, setInstructionDescription] = useState("")
    const [instructionListView, setInstructionListView] = useState(false);
    const [identity, setIdentity] = useState("");
    const [actionMode, setActionMode] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(6);
    const [goToPageInput, setGoToPageInput] = useState("");

    useEffect(() => {
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);
        if (props.gotoNewInst) {
            setInstructionListView(true)
            setIdentity("");
            setInstructionName("");
            setInstructionDescription("");
            setInstruction("");
        }
    }, [props.instructionDataSource, props.gotoNewInst]);

    const updateWindowDimensions = () => {
        setHeight(window.innerHeight);
    }

    // Calculate pagination data
    const totalItems = props?.instructionDataSource?.length || 0;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = props?.instructionDataSource?.slice(startIndex, endIndex) || [];
    const startResult = totalItems > 0 ? startIndex + 1 : 0;
    const endResult = Math.min(endIndex, totalItems);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setGoToPageInput("");
        // Scroll to top of the instruction list for better UX
        const instructionElement = document.querySelector('.sa-instruction');
        if (instructionElement) {
            instructionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Handle go to page input
    const handleGoToPage = (e) => {
        e.preventDefault();
        const pageNumber = parseInt(goToPageInput) - 1; // Convert to 0-based index
        if (pageNumber >= 0 && pageNumber < totalPages) {
            handlePageChange(pageNumber);
        } else {
            toast.error(`Please enter a page number between 1 and ${totalPages}`);
        }
    };

    // Generate page numbers with ellipsis
    const generatePageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            // Show all pages if total is less than max visible
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first page
            pages.push(0);
            
            if (currentPage > 2) {
                pages.push('ellipsis-start');
            }
            
            // Show pages around current page
            const start = Math.max(1, currentPage - 1);
            const end = Math.min(totalPages - 2, currentPage + 1);
            
            for (let i = start; i <= end; i++) {
                if (i !== 0 && i !== totalPages - 1) {
                    pages.push(i);
                }
            }
            
            if (currentPage < totalPages - 3) {
                pages.push('ellipsis-end');
            }
            
            // Always show last page
            if (totalPages > 1) {
                pages.push(totalPages - 1);
            }
        }
        
        return pages;
    };

    const onEditInstruction = (item) => {
        setInstructionName(item.name);
        setInstructionDescription(item.description);
        setInstruction(item.instruction);
        setIdentity(item.id);
        setInstructionListView(true);
        setActionMode('Edit');
        props._editInstruction(item.id)
    }

    const enableInstruction = () => {
        setInstructionListView(!instructionListView);
        setIdentity("");
        setInstructionName("");
        setInstructionDescription("");
        setInstruction("");
    }

    const closeInstrucionModal = () => {
        setInstructionListView(false);
        props._closeInstructModal(false);
    }

    const saveFileInstruction = () => {
        let extractInstruction = {}
        if(props.gotoNewInst){
            extractInstruction = {
                name: instructionName,
                description: instructionDescription,
                instructionType: extractTypes.EXTRACT,
                instruction: instruction,
            }
        }
        else{
         extractInstruction = {
            name: instructionName,
            description: instructionDescription,
            instruction: instruction,
            instructionType: extractTypes.EXTRACT,
            id: identity
        }
    }
    console.log('extractInstruction',extractInstruction)
        if (instructionName === "" && instructionName === undefined) {
            toast.error("Please enter name")
        }
        else if (instruction === "" && instruction === undefined) {
            toast.error("Please enter the instruction")
        }
        if(props.gotoNewInst){
            PromptService.createInstruction(extractInstruction).then((res) => {
                if (res.status === "SUCCESS") {
                    toast.success("Instruction Created Successfully")
                    enableInstruction();
                    props._renderInstructionList();
                    props._closeInstructModal(false);

                }
            }).catch(err => {
                // messageNotification("error", err.errorMessage)
            });
        }
        else{
        PromptService.updateInstructionList(extractInstruction,identity ).then((res) => {
            if (res.status === "SUCCESS") {
                toast.success("Instruction Updated Successfully")
                enableInstruction();
                props._renderInstructionList();
            }
        }).catch(err => {
            // messageNotification("error", err.errorMessage)
        });
    }
    }   

    // Render Grid View
    const renderGridView = () => (
        <Row className="g-3">
            {currentItems.map((item, index) => (
                <Col xl={4} lg={6} md={12} sm={12} xs={12} key={index}>
                    <Card className="h-100" style={{
                        border: '1px solid #e9ecef',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}>
                        <Card.Body className="p-3">
                            {/* Header */}
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <h6 className="text-uppercase txt-pink fw-bold mb-0 text-ellipsis" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                                    {item?.name || 'N/A'}
                                </h6>
                                <i 
                                    className="fas fa-edit text-primary" 
                                    style={{ 
                                        fontSize: '0.9rem', 
                                        cursor: 'pointer',
                                        padding: '4px',
                                        borderRadius: '4px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.transform = 'scale(1.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onEditInstruction(item);
                                    }}
                                    title="Edit Instruction"
                                ></i>
                            </div>

                            {/* Description Section */}
                            <div className="mb-3">
                                <div className="d-flex align-items-start">
                                    <i className="fas fa-align-left me-2 text-primary mt-1" style={{ fontSize: '0.9rem' }}></i>
                                    <div className="flex-grow-1">
                                        <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Description</small>
                                        <span className="fw-semibold text-ellipsis" style={{ fontSize: '0.85rem' }}>
                                            {item?.description || 'No description available'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Instruction Preview */}
                            <div className="mb-3">
                                <div className="d-flex align-items-start">
                                    <i className="fas fa-code me-2 text-primary mt-1" style={{ fontSize: '0.9rem' }}></i>
                                    <div className="flex-grow-1">
                                        <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Instruction</small>
                                        <div className="bg-light p-2 rounded" style={{ fontSize: '0.8rem', maxHeight: '60px', overflow: 'scroll' }}>
                                            {item?.instruction ? 
                                                item.instruction : 'No instruction available'
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );

    // Render List View
    const renderListView = () => (
        <div className="table-responsive">
            <Table hover className="mb-0">
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                        <th style={{ border: 'none', padding: '12px 16px', fontSize: '0.85rem', fontWeight: '600', color: '#495057' }}>Name</th>
                        <th style={{ border: 'none', padding: '12px 16px', fontSize: '0.85rem', fontWeight: '600', color: '#495057' }}>Description</th>
                        <th style={{ border: 'none', padding: '12px 16px', fontSize: '0.85rem', fontWeight: '600', color: '#495057' }}>Instruction</th>
                        <th style={{ border: 'none', padding: '12px 16px', fontSize: '0.85rem', fontWeight: '600', color: '#495057', width: '80px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item, index) => (
                        <tr key={index} style={{ borderBottom: '1px solid #e9ecef' }}>
                            <td style={{ padding: '16px', verticalAlign: 'middle' }}>
                                <div className="fw-bold text-uppercase txt-pink" style={{ fontSize: '0.8rem', letterSpacing: '0.5px' }}>
                                    {item?.name || 'N/A'}
                                </div>
                            </td>
                            <td style={{ padding: '16px', verticalAlign: 'middle' }}>
                                <div className="text-muted" style={{ fontSize: '0.85rem', maxWidth: '200px' }}>
                                    {item?.description || 'No description available'}
                                </div>
                            </td>
                            <td style={{ padding: '16px', verticalAlign: 'middle' }}>
                                <div 
                                    className="text-muted" 
                                    style={{ 
                                        fontSize: '0.8rem', 
                                        maxWidth: '300px',
                                        maxHeight: '60px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical'
                                    }}
                                >
                                    {item?.instruction || 'No instruction available'}
                                </div>
                            </td>
                            <td style={{ padding: '16px', verticalAlign: 'middle', textAlign: 'center' }}>
                                <i 
                                    className="fas fa-edit text-primary" 
                                    style={{ 
                                        fontSize: '1rem', 
                                        cursor: 'pointer',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#f8f9fa';
                                        e.target.style.transform = 'scale(1.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.transform = 'scale(1)';
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onEditInstruction(item);
                                    }}
                                    title="Edit Instruction"
                                ></i>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );

    return (
        <>
            <div className="sa-instruction mt-2">
                <Scrollbars autoHeight autoHeightMin={height - 200}>
                    <div className="p-3">
                        {currentItems && currentItems.length > 0 ? (
                            <>
                                {/* Content based on view mode */}
                                {props.viewMode === 'grid' ? renderGridView() : renderListView()}
                            </>
                        ) : (
                            <div className="text-center py-5">
                                <i className="fas fa-inbox text-muted" style={{ fontSize: '3rem' }}></i>
                                <p className="text-muted mt-3 mb-0">No instructions found.</p>
                            </div>
                        )}
                    </div>
                </Scrollbars>
                
                {currentItems && currentItems.length > 0 && totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3 p-3" style={{ 
                        backgroundColor: '#f8f9fa', 
                        borderTop: '1px solid #e9ecef',
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 10
                    }}>
                        <div className="d-flex align-items-center">
                            <div className="me-4">
                                <span className="text-muted" style={{ fontSize: '0.9rem' }}>
                                    Showing {startResult} to {endResult} of {totalItems} results
                                </span>
                            </div>
                            <div className="d-flex align-items-center">
                                <Form onSubmit={handleGoToPage} className="d-flex align-items-center">
                                    <label className="text-muted me-2" style={{ fontSize: '0.9rem' }}>
                                        Go to page:
                                    </label>
                                    <InputGroup style={{ width: '130px' }}>
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            max={totalPages}
                                            value={goToPageInput}
                                            onChange={(e) => setGoToPageInput(e.target.value)}
                                            placeholder="Page #"
                                            style={{
                                                fontSize: '0.85rem',
                                                border: '1px solid #ced4da',
                                                borderRadius: '4px 0 0 4px'
                                            }}
                                        />
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            style={{
                                                fontSize: '0.85rem',
                                                padding: '6px 12px',
                                                borderRadius: '0 4px 4px 0',
                                                border: 'none'
                                            }}
                                        >
                                            Go
                                        </Button>
                                    </InputGroup>
                                </Form>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <Pagination className="mb-0">
                                <Pagination.First
                                    onClick={() => handlePageChange(0)}
                                    disabled={currentPage === 0}
                                    style={{
                                        border: '1px solid #dee2e6',
                                        borderRadius: '4px 0 0 4px',
                                        backgroundColor: 'white'
                                    }}
                                />
                                    <Pagination.Prev
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 0}
                                    style={{
                                        border: '1px solid #dee2e6',
                                        borderRadius: '0',
                                        backgroundColor: 'white'
                                    }}
                                />
                                {generatePageNumbers().map((page, index) => {
                                    if (page === 'ellipsis-start' || page === 'ellipsis-end') {
                                        return (
                                            <Pagination.Ellipsis 
                                                key={`ellipsis-${index}`}
                                                disabled
                                                style={{
                                                    border: '1px solid #dee2e6',
                                                    borderRadius: '0',
                                                    backgroundColor: 'white'
                                                }}
                                            />
                                        );
                                    }
                                    
                                    return (
                                        <Pagination.Item
                                            key={page}
                                            active={page === currentPage}
                                            onClick={() => handlePageChange(page)}
                                            style={{
                                                border: '1px solid #dee2e6',
                                                borderRadius: '0',
                                                backgroundColor: page === currentPage ? '#007bff' : 'white',
                                                color: page === currentPage ? 'white' : '#495057'
                                            }}
                                        >
                                            {page + 1}
                                        </Pagination.Item>
                                    );
                                    })}

                                <Pagination.Next
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages - 1}
                                    style={{
                                        border: '1px solid #dee2e6',
                                        borderRadius: '0',
                                        backgroundColor: 'white'
                                    }}
                                />
                                
                                <Pagination.Last
                                    onClick={() => handlePageChange(totalPages - 1)}
                                    disabled={currentPage === totalPages - 1}
                                    style={{
                                        border: '1px solid #dee2e6',
                                        borderRadius: '0 4px 4px 0',
                                        backgroundColor: 'white'
                                    }}
                                />
                            </Pagination>
                        </div>
                    </div>
                )}
            </div>

            <Modal size="lg" className="sa-file-inst" show={instructionListView} onHide={closeInstrucionModal}>
                <ModalHeader closeButton>
                    <ModalTitle>File Instruction</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="field-wrap d-flex align-items-center mb-3">
                        <p className="w-50">
                            <label htmlFor="name" className="form-label d-block font14 font-bold">Name</label>
                            <input type="text" placeholder="Enter Name" className="w-100 font14"
                                onChange={(e) =>
                                    setInstructionName(e.target.value)
                                }
                                value={instructionName}
                            ></input>
                        </p>
                        <p className="w-50">
                            <label htmlFor="description" className="form-label d-block font14 font-bold">Description</label>
                            <input type="text" placeholder="Enter Description" className="w-100 font14"
                                onChange={(e) =>
                                    setInstructionDescription(e.target.value)
                                }
                                value={instructionDescription}
                            ></input>
                        </p>
                    </div>
                    <div>
                        <label htmlFor="instruction"
                            className="form-label d-block font14 font-bold">
                            Enter the label for extraction
                        </label>
                        <textarea className="form-control font14" value={instruction}
                            onChange={(e) =>
                                setInstruction(e.target.value)
                            } />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" className="btn-light" onClick={closeInstrucionModal}>Cancel</Button>
                    <Button size="sm" onClick={saveFileInstruction}>{props.gotoNewInst === true ? "Create" : "Update"}</Button>
                </ModalFooter>
            </Modal>

        </>
    )

}

export default Instructions;